module.exports = __webpack_public_path__ + "static/media/Profile-Pitcher.782adc2b.png";